// extracted by mini-css-extract-plugin
export default {"wrapper":"ILGyv4","row":"TXRR_X","row-min-price":"B59bpj","rowMinPrice":"B59bpj","title":"GbaQRK","price":"XSDslg","minOrder":"NCMGxd","total":"qUOU67"};